import { useEffect, useRef, type ReactNode } from 'react';
import { X } from 'lucide-react';

/** Painel que sobe de baixo no celular e vira diálogo centralizado em telas maiores. */
export function Sheet({ open, onClose, title, children, footer }: { open: boolean; onClose: () => void; title: ReactNode; children: ReactNode; footer?: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      onClose={onClose}
      onClick={(e) => e.target === ref.current && onClose()}
      className="fixed inset-x-0 bottom-0 top-auto m-0 flex max-h-[92dvh] w-full max-w-none flex-col rounded-t-3xl border border-line bg-white p-0 text-ink shadow-2xl backdrop:bg-ink/45 open:flex sm:inset-0 sm:m-auto sm:max-h-[85dvh] sm:w-[34rem] sm:rounded-3xl [&:not([open])]:hidden"
    >
      <div className="flex items-start justify-between gap-3 border-b border-line px-5 py-4">
        <div className="min-w-0 flex-1">{title}</div>
        <button aria-label="Fechar" onClick={onClose} className="-mr-1 rounded-full p-1.5 text-ink-3 hover:bg-paper-2 hover:text-ink">
          <X className="size-5" />
        </button>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">{children}</div>
      {footer && <div className="border-t border-line bg-white px-5 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">{footer}</div>}
    </dialog>
  );
}
